"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _IconBase = _interopRequireDefault(require("./IconBase"));

var _theme = require("../theme");

var _core = require("@emotion/core");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  ", ";\n  ", ";\n  line-height: 0;\n  vertical-align: middle;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var getSize = function getSize(_ref) {
  var size = _ref.size,
      theme = _ref.theme;
  var iconSize = isNaN(Number(size)) ? theme.components.icon.size[size] : theme.iconScale[size];
  return {
    display: 'inline-block',
    height: iconSize || '100%',
    width: iconSize || '100%'
  };
};

var getSVGStyle = function getSVGStyle(_ref2) {
  var color = _ref2.color,
      theme = _ref2.theme;
  return (0, _theme.css)((0, _defineProperty2.default)({}, 'svg', {
    fill: color && theme.palette[color],
    height: 'inherit',
    pointerEvents: 'none',
    width: 'inherit'
  }));
};

var IconUI = (0, _theme.styled)(_IconBase.default)(_templateObject(), getSize, getSVGStyle); // eslint-disable-next-line valid-jsdoc

/**
 * @component
 */

var Icon = function Icon(props) {
  return (0, _core.jsx)(IconUI, props);
};

var _default = Icon;
exports.default = _default;